
export const isIos = (): boolean => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent)
}
